import { Icon } from '@kanda-libs/ks-design-library';
import { FileDropHookProps } from './useFileDrop';

export interface FileDropCardProps
  extends Omit<
    FileDropHookProps,
    'show' | 'dragOverError' | 'finalFile' | 'removeFile'
  > {
  name: string;
}

const FileDropCard: React.FunctionComponent<FileDropCardProps> = function ({
  onDragOver,
  onDragLeave,
  onDrop,
  onInputClick,
  onInputChange,
  classNames,
  name,
}) {
  return (
    <div
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      className={classNames.wrapper}
    >
      <div className="flex flex-row mx-auto gap-x-4">
        <Icon icon="file-upload" size={60} className="my-auto" />
        <div className="flex flex-col gap-y-1 mx-auto">
          <p>Drag and drop a file here</p>
          <div className="flex flex-row gap-x-1">
            <div className="w-full border-b border-neutral-700 my-auto" />
            <p className="text-neutral-700 text-12-18-em-up">or</p>
            <div className="w-full border-b border-neutral-700 my-auto" />
          </div>
          <label
            htmlFor={`file-input-${name}`}
            className="border border-neutral-400 hover:border-purple-400 mt-1 bg-neutral-000 hover:bg-purple-50 rounded-sm py-1 text-neutral-700 hover:text-purple-400 cursor-pointer text-center"
          >
            Click to select a file
          </label>
          <input
            id={`file-input-${name}`}
            type="file"
            className="hidden"
            onClick={onInputClick}
            onChange={onInputChange}
          />
        </div>
      </div>
    </div>
  );
};

export default FileDropCard;
